module.exports = __webpack_public_path__ + "Mark-Simonson-Proxima-Nova-ScOsf-Thin-webfont.ba783194e1cbfaa59e32.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-ScOsf-Thin-webfont.ttf
// module id = ../../../../../src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-ScOsf-Thin-webfont.ttf
// module chunks = main styles